import { Switch } from '@mui/material';
import React, { useState, useEffect, useCallback } from 'react'
import { Col, Form, Row } from 'react-bootstrap';
// icons ----------------------------------
import {
  Settings,
  CircleCheck,
  CircleInfo,
  Lock,
  CalendarAlt,
  CloudUploadAlt,
  RefreshCw,
  OutlineAccessTimeFilled,
  ArrowRotateLeft,
  Save,
  Check,
  IdCard,
  Download,
  Cross,
  Clock
} from '../../../../../../../components/icons/Icons';
import { ToastContainer, toast } from "react-toastify";
// ---------------------------------------------------
import { indianLoaclStrigNumber, normalNumber, isValidIndianFormattedNumber, isValidIndianNumber, useSelect } from '../../../../../../../services/commonServices';
import { getTDSValidationRulePath, saveTDSValidationRulePath } from '../../../../../../../services/config';
import { getTdsValidation, initValiRules, tdsSaveData, initTdsState } from '../../../../../../../redux/slices/tdsSlice';
import { useDispatch } from 'react-redux';

const ValidationRules = () => {

  const user = JSON.parse(localStorage.getItem("user_data")) || {}
  const dispatch = useDispatch()
  const tdsStore = useSelect("tds")

  const [valiState, setValiState] = useState({
    userId: user.user_id,
    isAllowHraLandlordPan: "",
    landlordPanLimit: "",
    isAllowHraFormulaVerification: "",
    isAllowSection80C: "",
    section80CLimit: "",
    isAllowSection80DMedicalInsurance: "",
    section80DBaseLimit: "",
    section80DSeniorLimit: "",
    isAllowHomeLoanInterestValidation: "",
    homeLoanInterestLimit: "",
    isAllowMissingProofAutoRejection: "",
    missingProofAmountLimit: "",
    isAllowRentReceiptFrequency: "",
    frequencyType: "",
    isAllowDocumentQualityValidation: "",
    qualityThresholdType: "",
    isAllowMandatoryFieldValidation: "",
    isAllowHrOverridePermission: "",
    hrOverridePermissionType: [],

    isAllowTaxRegimeSwitch: "",
    switchDeadline: "",
    maxSwitchesType: "",
    ipAddress: ""
  })

  const [applyLateSubmition, setApplyLateSubmition] = useState("0")

  const handleInputAmountChange = ({ target: { name, value } }) => {
    if (isValidIndianNumber(value)) {
      setValiState((pre) => ({
        ...pre,
        [name]: value
      }))
    }
  }

  const getListValidatio = useCallback(() => {
    dispatch(getTdsValidation(`${getTDSValidationRulePath}${user.user_id}`))
  }, [])

  useEffect(() => {
    getListValidatio()
  }, [])

  const handleInputChange = ({ target: { value, name } }) => {
    setValiState((pre) => ({
      ...pre,
      [name]: value
    }))
  }

  const handleSwitchChange = ({ target: { name, checked } }) => {
    setValiState((pre) => ({
      ...pre,
      [name]: checked ? "1" : "0"
    }))
  }

  const toggleValue = (value) => {
    setValiState((prev) => ({
      ...prev,
      hrOverridePermissionType: prev.hrOverridePermissionType.includes(value)
        ? prev.hrOverridePermissionType.filter((v) => v !== value) // remove
        : [...prev.hrOverridePermissionType, value] // add
    }));
  };

  const resetForm = () => {
    setValiState((pre) => ({
      ...pre,
      userId: user.user_id,
      isAllowHraLandlordPan: "",
      landlordPanLimit: "",
      isAllowHraFormulaVerification: "",
      isAllowSection80C: "",
      section80CLimit: "",
      isAllowSection80DMedicalInsurance: "",
      section80DBaseLimit: "",
      section80DSeniorLimit: "",
      isAllowHomeLoanInterestValidation: "",
      homeLoanInterestLimit: "",
      isAllowMissingProofAutoRejection: "",
      missingProofAmountLimit: "",
      isAllowRentReceiptFrequency: "",
      frequencyType: "",
      isAllowDocumentQualityValidation: "",
      qualityThresholdType: "",
      isAllowMandatoryFieldValidation: "",
      isAllowHrOverridePermission: "",
      hrOverridePermissionType: [],
      isAllowTaxRegimeSwitch: "",
      switchDeadline: "",
      maxSwitchesType: "",
      ipAddress: ""
    }))
  }

  const submitValidationRules = (e) => {
    e.preventDefault()

    const formData = {
      path: saveTDSValidationRulePath,
      data: {
        userId: user.user_id,
        isAllowHraLandlordPan: valiState.isAllowHraLandlordPan,
        landlordPanLimit: normalNumber(valiState.landlordPanLimit),
        isAllowHraFormulaVerification: valiState.isAllowHraFormulaVerification,
        isAllowSection80C: valiState.isAllowSection80C,
        section80CLimit: normalNumber(valiState.section80CLimit),
        isAllowSection80DMedicalInsurance: valiState.isAllowSection80DMedicalInsurance,
        section80DBaseLimit: normalNumber(valiState.section80DBaseLimit),
        section80DSeniorLimit: normalNumber(valiState.section80DSeniorLimit),
        isAllowHomeLoanInterestValidation: valiState.isAllowHomeLoanInterestValidation,
        homeLoanInterestLimit: normalNumber(valiState.homeLoanInterestLimit),
        isAllowMissingProofAutoRejection: valiState.isAllowMissingProofAutoRejection,
        missingProofAmountLimit: normalNumber(valiState.missingProofAmountLimit),
        isAllowRentReceiptFrequency: valiState.isAllowRentReceiptFrequency,
        frequencyType: valiState.frequencyType,
        isAllowDocumentQualityValidation: valiState.isAllowDocumentQualityValidation,
        qualityThresholdType: valiState.qualityThresholdType,
        isAllowMandatoryFieldValidation: valiState.isAllowMandatoryFieldValidation,
        isAllowHrOverridePermission: valiState.isAllowHrOverridePermission,
        hrOverridePermissionType: valiState.hrOverridePermissionType.toString(),
        isAllowTaxRegimeSwitch: valiState.isAllowTaxRegimeSwitch,
        switchDeadline: valiState.switchDeadline,
        maxSwitchesType: valiState.maxSwitchesType,
        ipAddress: valiState.ipAddress
      }
    }
    const isAllEmpty = Object.entries(valiState)
      .filter(([key]) => key !== "userId") // userId को exclude किया
      .every(([_, value]) => value === "" || value === null || value === undefined || value === " ");
    if (isAllEmpty) {
      toast.error("Please select required fields first")
    } else {
      dispatch(tdsSaveData(formData))
    }
  }

  useEffect(() => {
    if (tdsStore.tdsSuccess) {
      toast.success(tdsStore.tdsMessage)
      dispatch(initTdsState())
    }

    if (tdsStore.tdsValiSuccess) {
      setValiState((pre) => ({
        ...pre,
        limitAccess: 0,
        userId: user.user_id,
        isAllowHraLandlordPan: tdsStore.tdsValiData.isAllowHraLandlordPan,
        landlordPanLimit: tdsStore.tdsValiData.landlordPanLimit,
        isAllowHraFormulaVerification: tdsStore.tdsValiData.isAllowHraFormulaVerification,
        isAllowSection80C: tdsStore.tdsValiData.isAllowSection80C,
        section80CLimit: tdsStore.tdsValiData.section80CLimit,
        isAllowSection80DMedicalInsurance: tdsStore.tdsValiData.isAllowSection80DMedicalInsurance,
        section80DBaseLimit: tdsStore.tdsValiData.section80DBaseLimit,
        section80DSeniorLimit: tdsStore.tdsValiData.section80DSeniorLimit,
        isAllowHomeLoanInterestValidation: tdsStore.tdsValiData.isAllowHomeLoanInterestValidation,
        homeLoanInterestLimit: tdsStore.tdsValiData.homeLoanInterestLimit,
        isAllowMissingProofAutoRejection: tdsStore.tdsValiData.isAllowMissingProofAutoRejection,
        missingProofAmountLimit: tdsStore.tdsValiData.missingProofAmountLimit,
        isAllowRentReceiptFrequency: tdsStore.tdsValiData.isAllowRentReceiptFrequency,
        frequencyType: tdsStore.tdsValiData.frequencyType,
        isAllowDocumentQualityValidation: tdsStore.tdsValiData.isAllowDocumentQualityValidation,
        qualityThresholdType: tdsStore.tdsValiData.qualityThresholdType,
        isAllowMandatoryFieldValidation: tdsStore.tdsValiData.isAllowMandatoryFieldValidation,
        isAllowHrOverridePermission: tdsStore.tdsValiData.isAllowHrOverridePermission,
        hrOverridePermissionType: tdsStore.tdsValiData.hrOverridePermissionType.split(","),
        isAllowTaxRegimeSwitch: tdsStore.tdsValiData.isAllowTaxRegimeSwitch,
        switchDeadline: tdsStore.tdsValiData.switchDeadline.slice(0, 10),
        maxSwitchesType: tdsStore.tdsValiData.maxSwitchesType,
        ipAddress: tdsStore.tdsValiData.ipAddress
      }))
      console.log("first --------", tdsStore.tdsValiData.hrOverridePermissionType.split(","))
      dispatch(initValiRules())
    }

  }, [tdsStore])


  return (
    <>
      <div className='d-flex align-items-center justify-content-between gap-1 mb-4'>
        <div>
          <h3 className='color-white font-weight-200'>Validation Rules – TDS Module</h3>
          <h5 className='color-gray font-14 font-weight-200'>Configure automated validation rules and thresholds for Form 12BB submissions</h5>
        </div>

        <div className='d-flex align-items-center justify-content-start gap-3'>
          <CircleCheck class_name={"green-text"} />
          <span className='color-gray font-14 font-weight-200'>All changes saved</span>
          <span className='color-gray font-12 font-weight-200'>Last updated: 2 hours ago</span>
        </div>
      </div>


      <div className='setting-border height-auto'>
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <CloudUploadAlt class_name='clndr-icon' />HRA Validation Rules</h3>
          <span className='color-gray font-14'> 2 rules configured</span>
        </div>

        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Landlord PAN Requirement</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Enforce PAN collection when annual rent exceeds threshold</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Rent {`>`} ₹1,00,000 requires landlord PAN</h3>

                <h5 className='px-5 encryption mt-4'>
                  Threshold Amount: &nbsp;
                  <input
                    name='landlordPanLimit'
                    value={indianLoaclStrigNumber(valiState.landlordPanLimit)}
                    onChange={handleInputAmountChange}

                    placeholder='1,00,000'
                    className='universal-input'
                    style={{
                      width: "100px"
                    }} />
                  &nbsp; per annum
                </h5>

              </div>
            </div>
            <Switch name="isAllowHraLandlordPan" checked={valiState.isAllowHraLandlordPan === "1"} onChange={handleSwitchChange} />
          </div>
          <div className='setting-switch-enbl-dsbl mt-2'>
            <div className='content px-4 d-flex align-items-center justify-content-start'>
              <CircleInfo class_name={'text-info'} />
              <div>
                <h5 className='color-gray font-weight-200 font-14'>Rule Impact: When enabled, submissions with annual rent above threshold will be automatically flagged if landlord PAN is missing.</h5>
                <h5 className='color-gray font-weight-200 font-14'>Action: Form approval will be blocked until PAN is provided.</h5>
              </div>
            </div>
          </div>

        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>HRA Formula Verification</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Auto-verify "least of three" calculation</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Auto-verify "least of three" formula</h3>
              </div>
            </div>
            <Switch name="isAllowHraFormulaVerification" checked={valiState.isAllowHraFormulaVerification === "1"} onChange={handleSwitchChange} />
          </div>
          <div className='setting-switch-enbl-dsbl mt-3'>
            <div className='content px-4 d-flex align-items-center justify-content-start'>
              <CircleInfo class_name={'text-info'} />
              <div>
                <h5 className='color-gray font-weight-200 font-14'>Auto-calculation: System will verify HRA exemption using the least of:</h5>
                <h5 className='color-gray font-weight-200 font-14'>Actual HRA received</h5>
                <h5 className='color-gray font-weight-200 font-14'>Rent paid minus 10% of basic salary</h5>
                <h5 className='color-gray font-weight-200 font-14'>50% of basic salary (metro) / 40% (non-metro)</h5>
              </div>
            </div>
          </div>

        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <CloudUploadAlt class_name='clndr-icon' />Deductions Validation Rules</h3>
          <span className='color-gray font-14'> 3 rules configured</span>
        </div>

        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Section 80C Limit Check</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Flag submissions exceeding 80C deduction limits</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Auto-flag if 80C {'>'} ₹1.5L</h3>

                <h5 className='px-5 encryption mt-4'>
                  Limit Amount: &nbsp;
                  <input
                    name="section80CLimit"
                    value={indianLoaclStrigNumber(valiState.section80CLimit)}
                    placeholder='1,00,000'
                    className='universal-input'
                    style={{
                      width: "100px"
                    }}
                    onChange={handleInputAmountChange}
                  />
                  &nbsp; statutory limit
                </h5>

              </div>
            </div>
            <Switch name="isAllowSection80C" checked={valiState.isAllowSection80C === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Section 80D Medical Insurance</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Validate medical insurance premium limits</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Auto-flag if 80D {'>'} ₹50K</h3>

                <h5 className='px-5 encryption mt-4'>
                  Base Limit: &nbsp;
                  <input
                    name="section80DBaseLimit"
                    value={indianLoaclStrigNumber(valiState.section80DBaseLimit)}
                    placeholder='1,00,000'
                    className='universal-input'
                    style={{
                      width: "100px"
                    }}
                    onChange={handleInputAmountChange}
                  />
                  &nbsp; for self & family
                </h5>

                <h5 className='px-5 encryption mt-4'>
                  Senior Citizen: &nbsp;
                  <input
                    name="section80DSeniorLimit"
                    value={indianLoaclStrigNumber(valiState.section80DSeniorLimit)}
                    placeholder='1,00,000'
                    className='universal-input'
                    style={{
                      width: "100px"
                    }}
                    onChange={handleInputAmountChange}
                  />
                  &nbsp; for parents 60+
                </h5>
              </div>
            </div>
            <Switch name="isAllowSection80DMedicalInsurance" checked={valiState.isAllowSection80DMedicalInsurance === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Home Loan Interest Validation</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Validate home loan interest deduction limits</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Auto-flag if interest {'>'} ₹2L (Section 24b)</h3>

                <h5 className='px-5 encryption mt-4'>
                  Interest Limit:&nbsp;
                  <input
                    name="homeLoanInterestLimit"
                    value={indianLoaclStrigNumber(valiState.homeLoanInterestLimit)}
                    placeholder='1,00,000'
                    className='universal-input'
                    style={{
                      width: "100px"
                    }}
                    onChange={handleInputAmountChange}
                  />
                  &nbsp; per annum
                </h5>
              </div>
            </div>
            <Switch name='isAllowHomeLoanInterestValidation' checked={valiState.isAllowHomeLoanInterestValidation === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      {/* ---------------------------------------- */}
      <div className='setting-border height-auto mt-4'>
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <CloudUploadAlt class_name='clndr-icon' />Proof Validation Rules</h3>
          <span className='color-gray font-14'> 3 rules configured</span>
        </div>

        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Missing Proof Auto-Rejection</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Automatically reject submissions with missing mandatory proofs</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Reject missing proofs automatically</h3>

                <h5 className='px-5 encryption mt-4'>
                  Limit Amount: &nbsp;
                  <input
                    name="missingProofAmountLimit"
                    value={indianLoaclStrigNumber(valiState.missingProofAmountLimit)}
                    placeholder='1,00,000'
                    className='universal-input'
                    style={{
                      width: "100px"
                    }}
                    onChange={handleInputAmountChange}
                  />
                  &nbsp; statutory limit
                </h5>

              </div>
            </div>
            <Switch name='isAllowMissingProofAutoRejection' checked={valiState.isAllowMissingProofAutoRejection === "1"} onChange={handleSwitchChange} />
          </div>
          <div className='setting-switch-enbl-dsbl mt-2 warning-bdr warning-bg'>
            <div className='content px-4 d-flex align-items-center justify-content-start warning-clr'>
              <CircleInfo class_name={'warning-clr'} />
              <div>
                <h5 className='font-weight-200 font-14'>Warning: When enabled, submissions will be automatically rejected if mandatory proofs are missing.</h5>
                <h5 className='font-weight-200 font-14'>Employees will need to resubmit with complete documentation.</h5>
              </div>
            </div>
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Rent Receipts Frequency Check</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Enforce minimum frequency for rent receipt uploads</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Require rent receipts every quarter</h3>

                <h5 className='px-5 encryption mt-4 d-flex align-items-center justify-content-start gap-3'>
                  Frequency:&nbsp;
                  <Form.Group>
                    <Form.Select
                      name="frequencyType"
                      value={valiState.frequencyType}
                      className='universal-input'
                      onChange={handleInputChange}
                      style={{ width: "200px" }}
                    >
                      <option value="">Select Type</option>
                      <option value={"month"}>Month</option>
                    </Form.Select>
                  </Form.Group>
                </h5>
              </div>
            </div>
            <Switch name='isAllowRentReceiptFrequency' checked={valiState.isAllowRentReceiptFrequency === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Document Quality Validation</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Auto-validate document quality and readability</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Auto-reject poor quality documents</h3>

                <h5 className='px-5 encryption mt-4 d-flex align-items-center justify-content-start gap-3'>
                  Quality Threshold:&nbsp;
                  <Form.Group>
                    <Form.Select
                      name="qualityThresholdType"
                      value={valiState.qualityThresholdType}
                      className='universal-input'
                      onChange={handleInputChange}
                      style={{ width: "200px" }}
                    >
                      <option value={""}>Select Quality</option>
                      <option value="Low (Basic readability)">Low (Basic readability)</option>
                    </Form.Select>
                  </Form.Group>
                </h5>
              </div>
            </div>
            <Switch name='isAllowDocumentQualityValidation' checked={valiState.isAllowDocumentQualityValidation === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      {/* ----------------------------------------- */}
      {/* ---------------------------------------- */}
      <div className='setting-border height-auto mt-4'>
        <div className='setting-card-header'>
          <h3 className='color-white font-weight-200'> <CloudUploadAlt class_name='clndr-icon' />General Validation Rules</h3>
          <span className='color-gray font-14'> 3 rules configured</span>
        </div>

        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Mandatory Fields Validation</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>ABlock approval if any mandatory field is missing</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Block approval if any mandatory field missing</h3>

              </div>
            </div>
            <Switch name='isAllowMandatoryFieldValidation' checked={valiState.isAllowMandatoryFieldValidation === "1"} onChange={handleSwitchChange} />
          </div>
          <div className='px-4'>
            <div className='setting-switch-enbl-dsbl mt-2'>
              <div className='px-4'>
                <h5 className='color-gray font-weight-200 font-14'>Mandatory Fields Include:</h5>

                <div className='d-flex align-items-center justify-content-between gap-2 mt-2'>
                  <div className='color-gray'>
                    <p> <Check class_name={"green-text"} /> &nbsp; Employee PAN   </p>
                    <p> <Check class_name={"green-text"} /> &nbsp; Regime Selection  </p>
                  </div>
                  <div className='color-gray'>
                    <p> <Check class_name={"green-text"} /> &nbsp; Basic Salary Details   </p>
                    <p> <Check class_name={"green-text"} /> &nbsp; Declaration Signature   </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>HR Override Permission</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Allow HR to override validation rules with justification</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Allow HR override</h3>

                <h5 className='px-5 encryption mt-4'>

                  <Form.Group>
                    <Form.Check name="hrOverridePermissionType" value="Require justification note" label="Require justification note" checked={valiState.hrOverridePermissionType.includes("Require justification note")} onChange={()=>toggleValue("Require justification note")} />
                    <Form.Check name="hrOverridePermissionType" value="RLog in audit trail" label="RLog in audit trail" checked={valiState.hrOverridePermissionType.includes("RLog in audit trail")} onChange={()=>toggleValue("RLog in audit trail")} />
                    <Form.Check name="hrOverridePermissionType" value="Require manager approval" label="Require manager approval" checked={valiState.hrOverridePermissionType.includes("Require manager approval")} onChange={()=>toggleValue("Require manager approval")} />
                  </Form.Group>
                </h5>
              </div>
            </div>
            <Switch name='isAllowHrOverridePermission' checked={valiState.isAllowHrOverridePermission === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='setting-border height-auto mt-4'>
        {/* --------------------------- */}
        <div className='px-4 mb-4 mt-4'>
          <div className='d-flex align-items-center justify-content-between gap-3'>
            <div className='d-flex align-items-center justify-content-start gap-3'>
              <div>
                <div className='d-flex align-items-center justify-content-start gap-3'>
                  <span className='padding-5-purple'>
                    <IdCard class_name='text-purple' />
                  </span>
                  <h3 className='font-weight-200 color-white' style={{ marginLeft: "2px" }}>Tax Regime Switching</h3>
                </div>

                <h5 className='px-5 font-weight-200 color-gray'>Control when employees can switch between old/new regime</h5>
                <h3 className='px-5 font-weight-200 color-white mt-3'>Allow regime switching during FY</h3>

                <h5 className='px-5 encryption mt-4 d-flex align-items-center justify-content-start gap-3'>
                  Switch Deadline:
                  <Form.Group>
                    <Form.Control type='date' name="switchDeadline" defaultValue={valiState.switchDeadline} onChange={handleInputChange} className='universal-input-one' style={{ width: "200px" }} placeholder='2025-10-11' />
                  </Form.Group>
                </h5>
                <h5 className='px-5 encryption mt-4 d-flex align-items-center justify-content-start gap-3'>
                  Max Switches:&nbsp;
                  <Form.Group>
                    <Form.Select name="maxSwitchesType" value={valiState.maxSwitchesType} onChange={handleInputChange} className='universal-input-one' style={{ width: "200px" }}>
                      <option value={""}>Select max switch type</option>
                      <option value={"Once per FY"}>Once per FY</option>
                    </Form.Select>
                  </Form.Group>
                </h5>


              </div>
            </div>
            <Switch name='isAllowTaxRegimeSwitch' checked={valiState.isAllowTaxRegimeSwitch === "1"} onChange={handleSwitchChange} />
          </div>
        </div>
        {/* --------------------------- */}
      </div>

      <div className='d-flex align-items-center justify-content-between mt-4 mb-4'>
        <div className='d-flex align-items-center justify-content-start gap-3'>
          <span className='color-white d-flex align-items-center gap-2 font-16'> <Clock /> Changes will take effect immediately after saving</span>
          <span className='color-gray font-14'>  14 validation rules configured • 3 sections active</span>
        </div>
        <div className='d-flex align-items-center justify-content-start gap-3'>
          <button className='universal-sec-btn border-radius-8px d-flex align-items-center justify-content-center gap-2' onClick={resetForm}><ArrowRotateLeft /> Reset to Defaults</button>
          <button className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2' onClick={submitValidationRules}><Save /> Save Changes</button>
        </div>
      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        className="toast-custom"
      />
    </>
  )
}

export default ValidationRules